import styled, { css } from "styled-components";

export const Container = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: end;
    bottom: 12px;
    right: 21px;
    z-index: 9999;
`

export const Button = styled.button`
     display: flex;
    justify-content: center;
    align-items: center;
    width: 43px;
    height: 43px;
    background: #06AB03;
    ${props => props.open && css`
        background: #5BBDE7;
    `};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
    border: none;
    cursor: pointer;
`

export const ButtonPlusMenu = styled.div`
    display: ${props => props.open ? 'flex' : 'none'};
    flex-direction: column;
    justify-content: space-between;
    width: 161px;
    height: 125px;
    box-sizing: border-box;
    padding: 10px;

    background: #FFFFFF;
    border: 1px solid #D2D2D2;
    border-radius: 2px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    margin-bottom: 10px;
    
    div {
        display: flex;
        justify-content: start;
        align-items: center;
        width: 100%;
        height: 20px;
        cursor: pointer;

        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 14px;
        color: #4D4D4D;
    }

    span {
        margin-left: 13px;
    }
`;